import addContentView from './addContentComponent.html';
import './addContentComponent.css';

export function addContentComponent() {
	return {
		bindings: {
			onAddContent: '&',
		},
		controllerAs: 'vm',
		controller: addContentComponentCtrl,
		template: addContentView,
	};
}

export class addContentComponentCtrl {
	constructor(Api, EventTracker, Identity, modal, Post) {
		'ngInject';
		this.Api = Api;
		this.EventTracker = EventTracker;
		this.Identity = Identity;
		this.modal = modal;
		this.Post = Post;
	}
	addContent() {
		this.Post.create().then(
			postId => {
				if (!Number(postId)) {
					// user canceled
					return;
				}
				this.EventTracker.save('create_post', {
					post_id: postId,
				});
				if (!this.Identity.can('submit_to_intel_tab')) {
					this.modal.alert({ text: 'Success! An editor will review and publish your submission.' });
					return;
				}
				if (this.onAddContent) {
					console.log('onAddConentPresent');
				}
				this.Api.get(`/v3/posts/${postId}`).then(post => {
					if (post) {
						this.onAddContent({ $post: post });
					}
				});
			},
			() => {}
		);
	}
}
